import { handleErrorResponse } from '../../helpers/handleErrorResponse';
import { axiosInstance } from './axiosInstance';

export const removeActiveSession = async () => {
  let response;

  try {
    response = await axiosInstance.post('/logout');
  } catch (err) {
    response = handleErrorResponse(err);
  }

  return response;
};
